import {IBaseInstrumentItem} from 'models/resources';

export const getInstrumentsCollectionByIds = (
  instrumentItemIds: number[],
  collection: IBaseInstrumentItem[]
): IBaseInstrumentItem[] => collection.filter((item) => instrumentItemIds.indexOf(item.id) !== -1);
